import type { Order } from "@commercetools/platform-sdk";
import { moneyToNumber } from "../commercetools/money";
import type { TiktokContentItem, TiktokPixelParameters } from "./types";

// Right now we only use one pixel for all markets so it can be hardcoded.
// If we need to use different pixels for different markets, we can make this dynamic later.
export const tiktokPixelId = "CHLSD0BC77U2H86LKGGG";

export const buildCompletePaymentEvent = (
	order: Order,
): TiktokPixelParameters => {
	const contents = order.lineItems.map(
		(lineItem): TiktokContentItem => ({
			content_id: lineItem.variant.sku,
			content_name: lineItem.name[order.locale ?? "en-US"],
			quantity: lineItem.quantity,
			price: moneyToNumber(lineItem.price.value),
		}),
	);

	const params: TiktokPixelParameters = {
		content_type: "product",
		contents,
		currency: order.totalPrice.currencyCode,
		value: moneyToNumber(order.totalPrice),
	};

	return params;
};
